import { Component, Input } from '@angular/core'
import { OrderPatch, OrderRead, OrdersService, UserMinimalDataRead, UserRead, UsersService } from '@app/generated'
import { NotificationService } from '@core/services/notification.service'
import { FormControl, FormGroup } from '@angular/forms'
import { ModalService } from '@core/services/modal.service'
import { LoaderService } from '@core/services/loader.service'
import { getItemTranslation } from '@app/general/utils/get-item-translation'
import { finalize, forkJoin } from 'rxjs'

@Component({
	selector: 'app-change-assignation',
	templateUrl: './change-assignation.component.html',
	styleUrl: './change-assignation.component.scss',
})
export class ChangeAssignationComponent {
	@Input() order?: OrderRead
	@Input() ids?: string[]
	users: UserRead[] = []
	orderPath: OrderPatch = {} as OrderPatch
	usersForm = {
		formGroup: new FormGroup({
			assigned_to: new FormControl<UserRead | UserMinimalDataRead | null>(null),
		}),
	}
	protected readonly getItemTranslation = getItemTranslation
	protected readonly confirmButtonText = $localize`Confirm`
	protected readonly cancelButtonText = $localize`Cancel`

	constructor(
		private ordersService: OrdersService,
		private notificationService: NotificationService,
		private modalService: ModalService,
		private loaderService: LoaderService,
		private usersService: UsersService,
	) {}

	ngOnInit() {
		this.fetchUsers()
		if (this.order) {
			this.usersForm.formGroup.patchValue({
				assigned_to: this.order.assigned_to,
			})
		} else {
			this.usersForm.formGroup.patchValue({
				assigned_to: null,
			})
		}
	}

	fetchUsers() {
		this.usersService.getUsers().subscribe({
			next: response => {
				this.users = response.items
			},
			error: error => {
				let message = $localize`Was not able to fetch users`
				if (error.code === 422) {
					message = $localize`Form contains errors`
				}
				this.notificationService.error(message)
			},
		})
	}

	updateUser() {
		this.orderPath = {
			assigned_to_id: this.usersForm.formGroup.controls.assigned_to.value?.id,
		}
		this.patchData()
	}

	cancelUpdateStatus() {
		this.modalService.modalRef.close(false)
	}

	private patchData() {
		if (this.ids && this.ids.length > 0) {
			forkJoin(
				this.ids.map((id: string) => {
					return this.ordersService.patchOrder(id, this.orderPath)
				}),
			).subscribe({
				next: () => {
					const newValue = this.users.find(
						assigned_to => assigned_to.id === this.usersForm.formGroup.controls.assigned_to.value?.id,
					)
					this.modalService.modalRef.close(newValue)
					this.ids!.length > 1
						? this.notificationService.success($localize`User successfully assigned to orders`)
						: this.notificationService.success($localize`User successfully assigned to order`)
				},
				error: () => {
					this.ids!.length > 1
						? this.notificationService.error($localize`Was not able to assign user to orders`)
						: this.notificationService.error($localize`Was not able to assign user to order`)
				},
			})
		} else if (this.order) {
			if (this.order.id) {
				this.ordersService
					.patchOrder(this.order.id, this.orderPath)
					.pipe(finalize(() => this.loaderService.disable()))
					.subscribe({
						next: () => {
							const newValue = this.users.find(
								assigned_to => assigned_to.id === this.usersForm.formGroup.controls.assigned_to.value?.id,
							)
							this.modalService.modalRef.close(newValue)
							this.notificationService.success($localize`User successfully assigned to order`)
						},
						error: () => {
							this.notificationService.error($localize`Was not able to assign user to order`)
						},
					})
			}
		}
	}
}
